import React from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { useValue } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'
import WhenCanAdjustInventoryOrder from 'pages/app/inventory/order/partials/WhenCanAdjustInventoryOrder'

function InventoryItemTotal ({ inventoryItemId, twoLines }) {
  const unitType = useValue('unit_type')

  const totalPath = ['globals.inventory.order_items', inventoryItemId, 'total'].join('.')
  const totalAmountPath = ['globals.inventory.order_items', inventoryItemId, 'total_amount'].join('.')
  const errorMaxTotalAmountPath = ['globals.inventory.order_items', inventoryItemId, 'error_max_total_amount'].join('.')
  const errorMinTotalAmountPath = ['globals.inventory.order_items', inventoryItemId, 'error_min_total_amount'].join('.')
  const [total] = useEnvValue(totalPath, 0)
  const [totalAmount] = useEnvValue(totalAmountPath, 0)
  const [errorMaxTotalAmount] = useEnvValue(errorMaxTotalAmountPath, null)
  const [errorMinTotalAmount] = useEnvValue(errorMinTotalAmountPath, null)

  const titleClassNames = twoLines ? 'block font-medium leading-5' : null;
  const subtitleClassNames = twoLines ? 'block text-sm text-gray-500 leading-5' : 'ml-2';

  return (
    <WhenCanAdjustInventoryOrder>
      {total
        ? (
          <span className={titleClassNames}>
            <Translation name='inventory.order.columns.total' data={{ amount: total, unit: unitType }} />
          </span>
          )
        : null}
      {totalAmount
        ? (
          <span className={subtitleClassNames}>
            <Translation name='inventory.order.columns.total_amount' data={{ amount: totalAmount }} />
          </span>
          )
        : null}
      {Number.isInteger(errorMaxTotalAmount)
        ? twoLines
          ? (
          <span className='block text-sm text-red-500 leading-5'>
            <Translation name='inventory.order.columns.total_amount_error1' data={{ max_amount: errorMaxTotalAmount, unit: unitType }} />
          </span>
          )
          : (
          <div className='text-red-500'>
            <Translation name='inventory.order.columns.total_amount_error2' data={{ max_amount: errorMaxTotalAmount, unit: unitType }} />
          </div>
          )
        : null}
      {Number.isInteger(errorMinTotalAmount) && errorMinTotalAmount > 1
        ? (
          <span className='block text-sm text-red-500 leading-5'>
            <Translation name='inventory.order.columns.min_order_error' data={{ min_amount: errorMinTotalAmount, unit: unitType }} />
          </span>
          )
        : null}
    </WhenCanAdjustInventoryOrder>
  )
}

export default observer(InventoryItemTotal)
